<template>
	<footer :id="id" class="bmed-component footer wrapper bg-bg-002 text-text-002">
		<div class="container h-full pt-8 pb-12">
			<div class="logo mb-8">
				<UiLogo 
					mode="secondary"
					@click="logoClick()"
				/>
			</div>
			<div class="flex flex-col lg:flex-row lg:justify-between items-stretch gap-9">
				<nav class="nav lg:w-1/2">
					<SearchBar class="searchbar" border-color="white"/>
					<div><a href="/about-us">About Us</a></div>
					<CategoryAccordion 
						v-if="categories && categories.length > 0"
						label="Categories"
						:list="categories"
						list-height="320px"
					/>
					<div>
						<UiButton
							v-if="!isAuth"
							label="Log In"
							width="auto"
							theme="transparent"
							:on-click="userLogin"
						/>
						<UiButton
							v-else
							label="Log Out"
							width="auto"
							theme="transparent"
							:on-click="userLogout"
						/>
					</div>
				</nav>
				<div class="copyright flex flex-col justify-end lg:w-1/2 lg:text-right text-tiny">
					<p>
						<a 
							class="underline" 
							href="https://api.atpoc.com/beta/ccpa/?origin=breakingmed" 
							target="_blank"
							@click="console.log('analytics')"
						>Access My Information or Delete My Information</a>
					</p>
					<p>
						<small>
							We appreciate our customers and hold ourselves to the highest 
							<a 
								class="underline" 
								href="https://atpointofcare.com/policies.html" 
								target="_blank"
								@click="console.log('analytics')"
							>privacy policy</a> standards.
						</small>
					</p>
					<p><small>&copy; Copyright {{ new Date().getFullYear() }} Kaplan North America, LLC. All Rights Reserved.</small></p>
					<p><small>Peer Reviewed Continuing Medical Education Courses | Free CME/CE Courses & Resources PROJECTS IN KNOWLEDGE, PROJECTS IN KNOWLEDGE AT THE INTERSECTION OF KNOWLEDGE AND OUTCOMES SINCE 1980, TX REPORTER, MEDIMAGE CASES, MEDIMAGE CASES PICTURES AND A THOUSAND WORDS, are registered trademarks of Kaplan North America, LLC and the At Point of Care mark is owned by Kaplan North America, LLC. 1515 West Cypress Creek Road, Ft. Lauderdale, FL 33309.</small></p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiLogo from '@/components/ui/Logo'
import UiButton from '@/components/ui/Button'
import SearchBar from '@/components/search/Bar'
import CategoryAccordion from '@/components/category/Accordion'

export default {
	name: 'PageFooter',
	props: {
		id: {
			type: String,
			default: 'pageFooter'
		}
	},
	components: {
		UiLogo,
		UiButton,
		SearchBar,
		CategoryAccordion
	},
	mixins: [
		globalMixins
	],
	methods: {
		logoClick() {
			this.analytics({
				event: 'Click',
				label: 'Logo | Home | Footer'
			})
		}
	}
}
</script>

<style src="@/assets/css/tailwind.css"></style>
<style src="@/assets/css/_config.css"></style>
<style src="@/assets/css/_global.css"></style>
<style src="@/assets/css/animations.css"></style>
<style src="@/assets/css/main.css"></style>
<style>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
</style>

<style scoped>
.logo { width: var(--logo-width-sm); }
.nav > * { margin-bottom: 0.75rem !important; }
.searchbar { max-width: 320px !important; }
.copyright > * { margin-bottom: 0.25rem !important; }
</style>